const actionTypes = {
    SET_SEARCH: 'SET_SEARCH',
    ADD_MORE_PRODUCTS: 'ADD_MORE_PRODUCTS'
};

module.exports = actionTypes;
